import { combineReducers, configureStore } from '@reduxjs/toolkit';
import documentDataReducer from './documentSlice';
import marketerDataReducer from './marketerSlice';
import navigationReducer from './navigationSlice';
import prospectDataReducer from './prospectSlice';

const rootReducer = combineReducers({
  navigationdata: navigationReducer,
  documentData: documentDataReducer,
  marketerData: marketerDataReducer,
  prospectData: prospectDataReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
